import { DataProxy, useApolloClient } from '@apollo/client';
import { useCallback } from 'react';

const APOLLO_CLEAR_CACHE_KEY = 'clearCache';

type ApolloClearCacheForQueryCallback = <TData, TVariables>(
  options: DataProxy.WriteQueryOptions<TData, TVariables> & {
    runGarbageCollection?: boolean;
  }
) => void;

const useApolloClearCacheForQuery = (): ApolloClearCacheForQueryCallback => {
  const client = useApolloClient();

  return useCallback(
    <TData, TVariables>(
      options: DataProxy.WriteQueryOptions<TData, TVariables> & {
        runGarbageCollection?: boolean;
      }
    ): void => {
      const variables = {
        ...options.variables,
        [APOLLO_CLEAR_CACHE_KEY]: true,
      } as unknown as TVariables;

      client.writeQuery({
        ...options,
        variables,
      });

      if (options.runGarbageCollection) {
        client.cache.gc();
      }
    },
    [client]
  );
};

export { useApolloClearCacheForQuery, APOLLO_CLEAR_CACHE_KEY };
